export default __webpack_public_path__ + "static/media/Graphik-Thin.927995dd.otf";